<template>
  <div>
    <!-- Alarm Data section -->
    <section
      class="pdf-item bg-white w-full p-4 border rounded-lg w-full mb-4"
      v-for="(item, index) in grouppedData"
    >
      <h4>{{ index }}</h4>

      <div class="grid grid-cols-3 grid-rows-2 gap-4 my-4">
        <template v-for="(val, key) of getSummaryData(index)">
          <div
            class="flex justify-between w-full rounded text-center px-2 py-2 w-16"
            :class="getSummaryColor(key)"
          >
            {{ key }}
            <strong>
              {{ val }}
            </strong>
          </div>
        </template>
      </div>

      <AnyChart
        class="justify-self-stretch border rounded-lg mb-4 ..."
        chartType="bar"
        :title="index"
        :reportData="getChartData(index)"
        :period="reportData.form.dataForm"
        :colorScheme="colors"
        :decimalSeparator="0"
        @rawChart="setChartBaseSource($event, index)"
      />
      <HistoricalReport
        class="my-4"
        :title="`Severity Count`"
        :assets="getAlarmReportHeader()"
        :items="item"
        :type="reportData.form.dataForm"
        :options="summaryOptions"
      />
      <SimpleTable
        class="my-4"
        :title="`Alarm List`"
        :headers="getAlarmHistories(index).header"
        :items="getAlarmHistories(index).items"
        :options="summaryOptions"
      />
    </section>
    <!-- Alarm Data section -->
  </div>
</template>
<script>
import HistoricalReport from '@/components/Reports/HistoricalReport'
import SimpleTable from '@/components/dx/SimpleTable'
import AnyChart from '@/components/Reports/AnyChart'
import { format, date, utc } from '@/helpers/datetime'
import moment from 'moment'
import PdfReportTemplate from '@/components/Reports/PdfReport'
import reportContentMixin from '@/mixins/ReportContent'

export default {
  mixins: [reportContentMixin],
  props: {
    period: {
      type: String
    },
    exportPdf: {
      type: Boolean
    }
  },
  components: {
    HistoricalReport,
    SimpleTable,
    AnyChart
  },
  data() {
    return {
      grouppedAssets: [],
      assets: [],
      assetsProperties: [],
      grouppedData: {},
      chartImage: [],
      summaryOptions: {
        allowToAdd: false,
        allowToRefetch: false,
        allowExporting: true
      },
      colors: [
        'rgb(229, 62, 62)',
        'rgb(74, 85, 104)',
        'rgb(197, 48, 48)',
        'rgb(236, 201, 75)',
        'rgb(66, 153, 225)',
        'rgb(72, 187, 120)'
      ]
    }
  },
  async mounted() {
    this.alarmReportData()
  },
  methods: {
    alarmReportData() {
      var bodyData = {}
      var headerData = [
        {
          type: 'string',
          text: 'Asset Id',
          value: 'Asset Id'
        }
      ]

      var _this = this
      // get asset list
      this.assets = [
        ...new Set(this.reportData.report.map((x) => x.FormulaData.GroupName))
      ]
      this.grouppedAssets = [
        ...new Set(this.reportData.report.map((x) => x.FormulaData.GroupName))
      ]

      for (var group of this.grouppedAssets) {
        // get report data
        var reportData = this.reportData.report.find(
          (x) => x.FormulaData.GroupName === group
        )

        // loop by historical date
        bodyData[group] = reportData.HistoricalAlarmValue.map(function (x) {
          var data = {
            date: _this.formattedDate(x.Timestamp),
            formulaGroup: group,
            unit: x.Unit
          }

          // loop by total asset/column
          var findAsset = _this.reportData.report.find(
            (y) => y.FormulaData.GroupName === group
          )

          // default historical assset value
          data[`ERROR`] = 0
          data[`FAILURE`] = 0
          data[`CRITICAL`] = 0
          data[`WARNING`] = 0
          data[`INFORMATIONAL`] = 0
          data[`TOTAL`] = 0

          if (findAsset) {
            var assetHistoryValue = findAsset.HistoricalAlarmValue.find(
              (y) => y.Timestamp === x.Timestamp
            )
            data[`ERROR`] = _this.formattedValue(
              assetHistoryValue.CountSeverity.ERROR,
              '',
              0
            )
            data[`FAILURE`] = _this.formattedValue(
              assetHistoryValue.CountSeverity.FAILURE,
              '',
              0
            )
            data[`CRITICAL`] = _this.formattedValue(
              assetHistoryValue.CountSeverity.CRITICAL,
              '',
              0
            )
            data[`WARNING`] = _this.formattedValue(
              assetHistoryValue.CountSeverity.WARNING,
              '',
              0
            )
            data[`INFORMATIONAL`] = _this.formattedValue(
              assetHistoryValue.CountSeverity.INFORMATIONAL,
              '',
              0
            )
            data[`TOTAL`] = _this.formattedValue(assetHistoryValue.TOTAL, '', 0)
          }

          return data
        })
      }

      this.grouppedData = bodyData
    },
    getAlarmReportHeader() {
      return [
        `ERROR`,
        `FAILURE`,
        `CRITICAL`,
        `WARNING`,
        `INFORMATIONAL`,
        `TOTAL`
      ]
    },
    getSummaryData(group) {
      var data = this.reportData.report.find(
        (y) => y.FormulaData.GroupName === group
      ).AlarmCountValue

      return {
        ERROR: this.formattedValue(data.CountSeverity.ERROR, '', 0),
        FAILURE: this.formattedValue(data.CountSeverity.FAILURE, '', 0),
        CRITICAL: this.formattedValue(data.CountSeverity.CRITICAL, '', 0),
        WARNING: this.formattedValue(data.CountSeverity.WARNING, '', 0),
        INFORMATIONAL: this.formattedValue(
          data.CountSeverity.INFORMATIONAL,
          '',
          0
        ),
        TOTAL: this.formattedValue(data.TOTAL, '', 0)
      }
    },
    getSummaryColor(severity) {
      if (severity === `ERROR`) {
        return 'bg-red-600 text-white'
      } else if (severity === `FAILURE`) {
        return 'bg-gray-700 text-white'
      } else if (severity === `CRITICAL`) {
        return 'bg-red-700 text-white'
      } else if (severity === `WARNING`) {
        return 'bg-yellow-500'
      } else if (severity === `INFORMATIONAL`) {
        return 'bg-blue-500 text-white'
      } else if (severity === `TOTAL`) {
        return 'bg-green-500 text-white'
      }
    },
    getAlarmHistories(group) {
      var headerData = [
        {
          type: 'date',
          text: 'Active Time',
          value: 'ActiveTime',
          format: 'd MMM yyyy HH:mm a'
        },
        {
          type: 'date',
          text: 'Resolved Time',
          value: 'ResolvedTime',
          format: 'd MMM yyyy HH:mm a'
        },
        {
          type: 'string',
          text: 'Location',
          value: 'DceLocation'
        },
        {
          type: 'string',
          text: 'Name',
          value: 'DceName'
        },
        {
          type: 'list',
          text: 'Severity',
          value: 'Severity'
        },
        {
          type: 'string',
          text: 'Description',
          value: 'Description'
        },
        {
          type: 'string',
          text: 'Status',
          value: 'State'
        }
      ]

      var bodyData = this.reportData.report.find(
        (y) => y.FormulaData.GroupName === group
      ).AlarmCountValue.ListAlarm

      return {
        header: headerData,
        items: bodyData
      }
    },
    getChartData(formulaGroup) {
      var _this = this
      var reportData = this.reportData.report.find(
        (x) => x.FormulaData.GroupName === formulaGroup
      )

      var chartData = []
      for (var dataset of this.getAlarmReportHeader()) {
        var newDataset = {
          FormulaData: {},
          HistoricalValue: []
        }

        newDataset['FormulaData'] = JSON.parse(
          JSON.stringify(reportData.FormulaData)
        )
        newDataset['FormulaData'].GroupName = dataset
        newDataset['HistoricalValue'] = reportData.HistoricalAlarmValue.map(
          (x) => ({
            Timestamp: x.Timestamp,
            DecimalVal:
              dataset === 'Timestamp' || dataset === 'TOTAL'
                ? x[dataset]
                : x.CountSeverity[dataset]
          })
        )
        chartData.push(newDataset)
      }

      return chartData
    },
    preparePdf() {
      try {
        var _this = this

        PdfReportTemplate.clear()
        // set pdf title
        PdfReportTemplate.setTitle(
          `${this.period} ${this.reportData.form.reportType}`
        )

        // cover page
        PdfReportTemplate.addCover(_this.customerLogo)
        for (var header of this.reportHeader) {
          PdfReportTemplate.append({
            columns: [
              {
                // auto-sized columns have their widths based on their content
                width: 80,
                style: ['coverTitle'],
                text: header.name,
                alignment: 'left'
              },
              {
                width: '*',
                text: `: ${header.content}`,
                style: ['coverTitleVal'],
                alignment: 'left'
              }
            ],
            margin: [0, 10]
          })
        }

        // toc page
        PdfReportTemplate.newPage()
        PdfReportTemplate.addTOC()

        // report content
        Object.keys(this.grouppedData).forEach(function (index) {
          PdfReportTemplate.setOrientation('portrait')

          var severityCountHeader = [_this.dateColumnLabel()].concat(
            _this.getAlarmReportHeader()
          )
          var severityCountBody = JSON.parse(
            JSON.stringify(_this.grouppedData[index])
          ).map(function (x) {
            for (var property in x) {
              x[property] = {
                text: x[property],
                alignment: 'right'
              }
            }

            // set date
            x.Date = _this.readableFormattedDate(x.date.text)
            x[_this.dateColumnLabel()] = x.Date

            return x
          })

          // header
          PdfReportTemplate.addHeader(index)

          // Sum
          var sum = _this.getSummaryData(index)
          PdfReportTemplate.append({
            text: 'Summary Data:',
            bold: true,
            margin: [0, 0, 0, 10]
          })
          PdfReportTemplate.append({
            columns: [
              {
                ul: [
                  `ERROR : ${sum.ERROR}`,
                  `FAILURE : ${sum.FAILURE}`,
                  `CRITICAL : ${sum.CRITICAL}`
                ],
                width: 150
              },
              {
                ul: [
                  `WARNING : ${sum.WARNING}`,
                  `INFORMATIONAL : ${sum.INFORMATIONAL}`,
                  `TOTAL : ${sum.TOTAL}`
                ],
                width: '*'
              }
            ]
          })

          // Severity Count Header
          PdfReportTemplate.addSubHeader('Severity Count')

          // adding chart image
          var chartImage = _this.chartImage.find((x) => x.name === index)
          PdfReportTemplate.append({
            image: chartImage ? chartImage.source[0] : '',
            width: 500,
            margin: [0, 0, 0, 10],
            alignment: 'center'
          })

          // appending severity count table
          PdfReportTemplate.append(
            PdfReportTemplate.table(severityCountBody, severityCountHeader)
          )
          PdfReportTemplate.setOrientation('landscape')

          // Alarm List table
          PdfReportTemplate.addSubHeader('Alarm  List')
          PdfReportTemplate.append(
            PdfReportTemplate.tableObject(
              JSON.parse(JSON.stringify(_this.getAlarmHistories(index).items))
                .map(function (x) {
                  x.ActiveTime = _this.formattedDateTime(x.ActiveTime)
                  x.ResolvedTime = _this.formattedDateTime(x.ResolvedTime)

                  return x
                })
                .slice(0, 50),
              _this.getAlarmHistories(index).header
            )
          )

          PdfReportTemplate.append({
            text:
              '(*) to see the entire Alarm List, you can view it via Tenant Portal or Excel Report',
            margin: [0, 0, 0, 10],
            style: ['quote', 'small']
          })
        })

        this.$emit('pdfSource', {
          filename: this.getGeneratedFileName(),
          source: PdfReportTemplate.template
        })
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>
